module.exports = __webpack_public_path__ + "img/Bl.ad6d9620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/Bl.jpg
// module id = 3nLy
// module chunks = 1